<app-modal [activeModal]="activeModal" [closeBtnLabel]="closeBtnLabel" [onClose]="submit" [title]="title">
  <div #container [ngStyle]="{ 'max-height': 'inherit' }">
    <img [src]="imageUrl" class="mx-auto block h-full max-w-full opacity-0" #image alt="Kadrowany obraz" i18n-alt />
  </div>
</app-modal>
